<template>
  <div class="p-6 min-w-max h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Inbox</p>
      <BaseRoundedButton @click="handleMarkAsRead">
        <p class="font-sans">Mark as read</p>
      </BaseRoundedButton>
    </div>
    <div>
      <table class="table-auto w-full">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-lg">
            <th class="py-2 font-normal">First Name</th>
            <th class="py-2 font-normal">Last Name</th>
            <th class="py-2 font-normal">Email</th>
            <th class="py-2 font-normal">Phone</th>
            <th class="py-2 font-normal">Subject</th>
            <th class="py-2 font-normal">Comments/Questions</th>
            <th class="py-2 font-normal">Status</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="message in inbox" :key="message.id" class="text-lg align-top">
            <td class="pb-4">
              <div v-if="message.first_name == 'null'">N/A</div>
              <div v-else>{{ message.first_name }}</div>
            </td>
            <td>
              <div v-if="message.last_name == 'null'">N/A</div>
              <div v-else>{{ message.last_name }}</div>
            </td>
            <td class="w-52 pr-4">
              <div v-if="message.email == 'null'">N/A</div>
              <div v-else>{{ message.email }}</div>
            </td>
            <td>
              <div v-if="message.phone_number == 'null'">N/A</div>
              <div v-else>{{ message.phone_number }}</div>
            </td>
            <td>
              <div v-if="message.subject == 'null'">N/A</div>
              <div v-else>{{ message.subject }}</div>
            </td>
            <td class="w-72">
              <div v-if="message.comment_question == 'null'">N/A</div>
              <div v-else>{{ message.comment_question }}</div>
            </td>
            <td>
              <div v-if="message.read == true" class="bg-light-gray flex items-center rounded-full justify-center">
                <p class="text-gray font-light">Read</p>
              </div>
              <div v-else class="bg-light-blue flex items-center rounded-full justify-center">
                <p class="text-blue font-light">Unread</p>
              </div>
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton>
                    <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                  </MenuButton>
                  <MenuItems class="
                                p-1
                                space-y-1
                                absolute
                                top-8
                                right-8
                                z-50
                                bg-white
                                border border-light-gray
                                shadow-md
                                rounded-lg
                                w-12/12
                              ">
                    <MenuItem v-if="message.read == false" @click="handleMarkRead(message.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <EnvelopeOpenIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Mark as Read</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleBlock(message.id)" class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <NoSymbolIcon class="text-red w-5 h-5 mr-4" />
                      <p class="text-red">Block</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleDelete(message.id)" class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-max">
                      <TrashIcon class="text-red w-5 h-5 mr-4" />
                      <p class="text-red">Delete</p>
                    </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-auto flex justify-end">
      <BasePagination @navigateToPage="handlePagination($event)" :pageCount="meta.last_page" />
    </div>
  </div>
</template>

<script>
import userService from "../Services/user.service";
import {
  EllipsisVerticalIcon,
  EnvelopeOpenIcon,
  TrashIcon,
  NoSymbolIcon,
} from "@heroicons/vue/24/outline";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { useToast } from "vue-toastification";
import BasePagination from "../components/BasePagination.vue";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
export default {
  name: "Inbox",
  components: {
    EllipsisVerticalIcon,
    EnvelopeOpenIcon,
    TrashIcon,
    NoSymbolIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    BasePagination,
    BaseRoundedButton,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      inbox: [],
      meta: [],
      params: new URLSearchParams(),
    };
  },
  methods: {
    getMessage() {
      userService.getInboxMessage(this.params).then((response) => {
        this.inbox = response.data.data;
        this.meta = response.data.meta;
      });
    },
    handleMarkRead(value) {
      this.$Progress.start();
      userService
        .markMessageRead(value)
        .then(() => {
          this.$Progress.finish();
          this.getMessage();
          this.getDashBoardSummray();
          this.toast.success("Marked as read.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot mark as read.");
          console.log(error);
        });
    },
    handleBlock(value) {
      this.$Progress.start();
      userService
        .storeBlockMessage(value)
        .then(() => {
          this.$Progress.finish();
          this.getMessage();
          this.toast.success("Blocked message successful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot block this message.");
          console.log(error);
        });
    },
    handleDelete(value) {
      this.$Progress.start();
      userService
        .delMessage(value)
        .then(() => {
          this.$Progress.finish();
          this.getMessage();
          this.getDashBoardSummray();
          this.toast.success("Delete message succesful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot delete this message.");
          console.log(error);
        });
    },
    handlePagination(value) {
      this.params.set("page", value);
      this.getMessage(this.params.toString());
    },
    getDashBoardSummray() {
      userService.getDashboard().then((response) => {
        this.$store.commit("setInboxCount", response.data.unread_inbox);
      });
    },
    handleMarkAsRead() {
      let unreadIds = [];
      this.inbox.forEach((item) => {
        if (item.read == false) {
          unreadIds.push(item.id);
        }
      });

      unreadIds = "[" + unreadIds + "]";

      let formData = new FormData();
      formData.append("ids", unreadIds);

      userService.markMultipleMessageRead(formData).then(() => {
        this.getMessage();
        this.getDashBoardSummray();
        this.toast.success("Marked messages as read for this page.");
      });
    }
  },
  created() {
    this.$Progress.start();
    this.getMessage();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped></style>